import { defineElement, html, TemplateElement, unsafeHTML } from '@webtides/element-js';
import '../../../../src/components/@e-banking/components/e-banking-picture/e-banking-picture.js';
import { getFocalAreaImageAttributes, getImageAttributes } from '@/services/content-service.js';
import { getImageMetaData } from '@/mgnl/utils/magnolia.js';

class EditablePicture extends TemplateElement {
    properties() {
        return {
            content: {},
        };
    }

    injectProperties() {
        return { environment: null };
    }

    get image() {
        const layout = this.content.imageLayout;

        if (layout && layout !== 'original') {
            return getFocalAreaImageAttributes(this.environment, this.content?.image, layout, 800);
        }
        return getImageAttributes(this.environment, this.content?.image, 800);
    }

    get meta() {
        return getImageMetaData(this.content?.image);
    }

    template() {
        return html`<mb-e-banking-picture .image="${this.image}" .meta="${this.meta}"></mb-e-banking-picture> `;
    }
}

defineElement('editable-picture', EditablePicture);
